export { default } from './CarLandscapeView';
